import { firebase, disconnectDb } from 'app-modules/application/utils/firebase';
import { LOAD_SCORE } from './types';
import { triviaFetchRankingPositionActionThunk as fetchRankingPosition } from './fetchRankingPosition';
import { triviaAuthenticatedUserIdSelector } from '../selectors/authenticatedUserId';

export const triviaLoadScoreActionThunk = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const authenticatedUserId = triviaAuthenticatedUserIdSelector(state);
    await dispatch({ type: LOAD_SCORE.REQUEST });
    const db = firebase.database();
    db.goOnline();

    let score = 0;
    if (authenticatedUserId) {
      const userScoreSnapshot = await db.ref(`/scores/${authenticatedUserId}`).once('value');

      if (userScoreSnapshot.exists()) {
        score = userScoreSnapshot.val();
      }
    } else {
      const deviceID = state.device.ID;
      const deviceScoreSnapshot = await db.ref(`/devices/${deviceID}/score`).once('value');
      if (deviceScoreSnapshot.exists()) {
        score = deviceScoreSnapshot.val();
      }
    }
    await dispatch({ type: LOAD_SCORE.SUCCESS, payload: { score } });
    await dispatch(fetchRankingPosition());
  } catch (err) {
    await dispatch({ type: LOAD_SCORE.FAILURE, payload: err, error: true });
  } finally {
    disconnectDb();
  }
};
